import { Backdrop, Box, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";

const CustomSpinner = () => {
  const spinnerFlag = useSelector(
    (state) => state.spinnerReducer.spinnerFlag
  );
  const spinnerText = useSelector(
    (state) => state.spinnerReducer.spinnerText
  );
  return (
    <>
      {spinnerFlag && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) =>
              Math.max.apply(Math, Object.values(theme.zIndex)) + 1,
          }}
          open={true}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              alignItems: "center",
            }}
          >
            <CircularProgress color="inherit" />
            <p>{spinnerText}</p>
          </Box>
        </Backdrop>
      )}
    </>
  );
};
export default CustomSpinner;
